const boosts = [
	{
		path: '/tv/boosts',
		name: 'tv-boosts-list',
		component: () => import('@/views/tv/boosts/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,boosts',
		},
	},
]

export default boosts
